/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingorganizerdescription2Inputs */

const en_onboardingorganizerdescription2 = /** @type {(inputs: Onboardingorganizerdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You run events, also at changing places.`)
};

const de_onboardingorganizerdescription2 = /** @type {(inputs: Onboardingorganizerdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du machst Veranstaltungen, auch an wechselnden Orten.`)
};

/**
* | output |
* | --- |
* | "You run events, also at changing places." |
*
* @param {Onboardingorganizerdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingorganizerdescription2 = /** @type {((inputs?: Onboardingorganizerdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingorganizerdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingorganizerdescription2(inputs)
	return de_onboardingorganizerdescription2(inputs)
});
export { onboardingorganizerdescription2 as "onboardingOrganizerDescription" }